import { SearchCustomersQuery } from '../types';
import { cleanSearchQuery } from '../../../services/phone/cleanPhoneNumber';
import encodeRFC3986URIComponent from '../../../../helpers/encodeRFC3986URIComponent';

const buildQueryPath = ({
    basePath,
    filters = {},
}: {
    basePath: string;
    filters?: Omit<SearchCustomersQuery, 'queryOptions' | 'agentId'>
}) => {
    const {
        searchQuery,
        createdAt,
        preferredLanguage,
        tags,
        hasNewMessage,
        sortBy,
        sortOrder,
        pageSize,
        page,
    } = filters;
    const params = [];
    if (searchQuery) {
        const cleanedQuery = cleanSearchQuery(searchQuery);
        params.push(`query=${encodeRFC3986URIComponent(cleanedQuery)}`);
    }
    if (createdAt) {
        params.push(`createdAt=${encodeURIComponent(createdAt)}`);
    }
    if (preferredLanguage) {
        params.push(`preferredLanguage=${encodeURIComponent(preferredLanguage)}`);
    }
    if (tags) {
        params.push(`tags=${encodeURIComponent(tags)}`);
    }
    if (hasNewMessage) {
        params.push(`hasNewMessage=${encodeURIComponent(hasNewMessage)}`);
    }
    if (sortBy) {
        params.push(`sortBy=${encodeURIComponent(sortBy)}`);
    }
    if (sortOrder) {
        params.push(`sortOrder=${encodeURIComponent(sortOrder)}`);
    }
    if (pageSize) {
        params.push(`pageSize=${encodeURIComponent(pageSize)}`);
    }
    if (page) {
        params.push(`page=${encodeURIComponent(page)}`);
    }
    return `${basePath}?${params.join('&')}`;
};

export default buildQueryPath;
